export const ADD_USER_DATA = 'ADD_USER_DATA';
export const RESET_USER = 'RESET_USER';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case ADD_USER_DATA:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
}
